import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosRequestHeaders } from 'axios';
import { genericErrorMessage } from '@/services/apiFetch';

const baseURL = 'https://portal.palmettoeoc.com/prod/public/api/cognito/account';

export const verifyToken = createAsyncThunk<
  IUserPortal,
  string,
  { rejectValue: { message: string } }
>('verifyTokenThunk', async (token: string) => {
  const headers = {
    Authorization: token,
  } as AxiosRequestHeaders;

  try {
    const response = await axios.get(baseURL, { headers });
    return response.data as IUserPortal;
  } catch (error) {
    let message = genericErrorMessage;
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    throw Error(message);
  }
});
